import * as React from 'react';

import { AnimatePresence } from 'framer-motion';

import { isPassword } from '@webapp/utils/validators/index';

import InputField from '@components/form/input';
import AnimatedHintCtrl from '@webapp/controllers/animated-hint';

interface PasswordCtrlProps {
  className?: string;
  password: string;
  onChange: (value: string) => void;
  onFocus?: () => void;
  autoComplete?: string;
  label?: React.ReactNode;
  error?: React.ReactNode;
  name?: string;
  isGrey?: boolean;
}

export const PasswordCtrl: React.FC<PasswordCtrlProps> = (props) => {
  const [invalidPassword, setInvalidPassword] = React.useState('');

  const validatePassword = () => {
    if (props.password.length >= 1 && !isPassword(props.password)) {
      setInvalidPassword('Invalid Password');
    } else {
      setInvalidPassword('');
    }
  };

  return (
    <>
      <InputField
        id="password"
        className={props.className}
        name={props.name ? props.name : 'password'}
        autoComplete={props.autoComplete || 'password'}
        type="password"
        value={props.password}
        label={props.label || 'Password'}
        isGrey={props.isGrey}
        error={props.error ? props.error : invalidPassword}
        onChange={(value) => props.onChange(value)}
        onBlur={() => validatePassword()}
        onFocus={() => {
          setInvalidPassword('');
          if (props.onFocus) {
            props.onFocus();
          }
        }}
      />
      <AnimatePresence exitBeforeEnter>
        {invalidPassword ? (
          <AnimatedHintCtrl key="error-password-hint">
            At least 8 characters, with numbers and letters
          </AnimatedHintCtrl>
        ) : null}
      </AnimatePresence>
    </>
  );
};

export default PasswordCtrl;
